import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [{
    path: '/Login',
    component: resolve => require(['@/views/Login.vue'], resolve),
  }, {
    path: '/',
    component: resolve => require(['@/views/index.vue'], resolve),
    redirect: '/charts/index',
  },
  {
    path: '/index',
    component: resolve => require(['@/views/index.vue'], resolve),
    redirect: '/charts/index',
    children: [
      //首页
      {
        path: '/role/index',
        component: resolve => require(['@/views/role/index.vue'], resolve)
      },
      //首页
      {
        path: '/users/index',
        component: resolve => require(['@/views/users/index.vue'], resolve)
      },
      {
        path: '/users/userdata',
        component: resolve => require(['@/views/users/userdata.vue'], resolve)
      },
      {
        path: '/dev/devlist',
        component: resolve => require(['@/views/dev/devlist.vue'], resolve)
      },
      {
        path: '/dev/rundev',
        component: resolve => require(['@/views/dev/rundev.vue'], resolve)
      },
      {
        path: '/dev/devinfo',
        component: resolve => require(['@/views/dev/devinfo.vue'], resolve)
      },
      {
        path: '/dev/devswitch',
        component: resolve => require(['@/views/dev/devswitch.vue'], resolve)
      },
      {
        path: '/dev/devbind',
        component: resolve => require(['@/views/dev/devbind.vue'], resolve)
      },
      {
        path: '/dev/devusers',
        component: resolve => require(['@/views/dev/devusers.vue'], resolve)
      },
      {
        path: '/dev/devtype',
        component: resolve => require(['@/views/dev/devtype.vue'], resolve)
      },
      {
        path: '/orders/index',
        component: resolve => require(['@/views/package/orders'], resolve)
      },
      {
        path: '/single/index',
        component: resolve => require(['@/views/single/index.vue'], resolve)
      },
      {
        path: '/single/add',
        component: resolve => require(['@/views/single/add.vue'], resolve)
      },
      {
        path: '/charts/index',
        component: resolve => require(['@/views/charts/index.vue'], resolve)
      },
      {
        path: '/charts/add_single',
        component: resolve => require(['@/views/charts/add_single.vue'], resolve)
      },
      {
        path: '/factory/charts',
        component: resolve => require(['@/views/factory/charts.vue'], resolve)
      },
      {
        path: '/factory/index',
        component: resolve => require(['@/views/factory/index.vue'], resolve)
      },
      {
        path: '/factory/add_company',
        component: resolve => require(['@/views/factory/add_company.vue'], resolve)
      },
      {
        path: '/factory/channel',
        component: resolve => require(['@/views/factory/channel.vue'], resolve)
      },
      {
        path: '/factory/add_channel',
        component: resolve => require(['@/views/factory/add_channel.vue'], resolve)
      },
      {
        path: '/factory/network',
        component: resolve => require(['@/views/factory/network.vue'], resolve)
      },
      {
        path: '/factory/add_network',
        component: resolve => require(['@/views/factory/add_network.vue'], resolve)
      },
      {
        path: '/version/index',
        component: resolve => require(['@/views/version/index.vue'], resolve)
      },
      {
        path: '/package/index',
        component: resolve => require(['@/views/package/index.vue'], resolve)
      },
      {
        path: '/config/custom',
        component: resolve => require(['@/views/config/custom.vue'], resolve)
      },
      {
        path: '/consume/brand',
        component: resolve => require(['@/views/consume/brand.vue'], resolve)
      },
      {
        path: '/config/menus',
        component: resolve => require(['@/views/config/menus.vue'], resolve)
      },
      {
        path: '/config/language',
        component: resolve => require(['@/views/config/language.vue'], resolve)
      },
      {
        path: '/config/site',
        component: resolve => require(['@/views/config/site.vue'], resolve)
      },
      {
        path: '/config/quick',
        component: resolve => require(['@/views/config/quick.vue'], resolve)
      },
      {
        path: '/config/password',
        component: resolve => require(['@/views/config/password.vue'], resolve)
      },
      {
        path: '/admin/index',
        component: resolve => require(['@/views/admin/index.vue'], resolve)
      },
      {
        path: '/admin/add',
        component: resolve => require(['@/views/admin/add.vue'], resolve)
      },
      {
        path: '/warning/index',
        component: resolve => require(['@/views/warning/index.vue'], resolve)
      },
      {
        path: '/warning/devlist',
        component: resolve => require(['@/views/warning/devlist.vue'], resolve)
      },
      {
        path: '/consume/analysis',
        component: resolve => require(['@/views/consume/analysis.vue'], resolve)
      },
      {
        path: '/consume/comprehensive',
        component: resolve => require(['@/views/consume/comprehensive.vue'], resolve)
      },
      {
        path: '/consume/forecast',
        component: resolve => require(['@/views/consume/forecast.vue'], resolve)
      },
      {
        path: '/car_house/index',
        component: resolve => require(['@/views/car_house/index.vue'], resolve)
      },
      {
        path: '/car_house/parts',
        component: resolve => require(['@/views/car_house/parts.vue'], resolve)
      },
      {
        path: '/car_house/add_parts',
        component: resolve => require(['@/views/car_house/add_parts.vue'], resolve)
      },
      {
        path: '/car_house/configure',
        component: resolve => require(['@/views/car_house/configure.vue'], resolve)
      },
      {
        path: '/car_house/add_config',
        component: resolve => require(['@/views/car_house/add_config.vue'], resolve)
      },
      {
        path: '/photos/index',
        component: resolve => require(['@/views/photos/index.vue'], resolve)
      },
      {
        path: '/photos/category',
        component: resolve => require(['@/views/photos/category.vue'], resolve)
      },
      {
        path: '/customer/index',
        component: resolve => require(['@/views/customer/index.vue'], resolve)
      },
      {
        path: '/customer/add',
        component: resolve => require(['@/views/customer/add.vue'], resolve)
      },
    ]
  },
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})